// 調證建議頁面翻譯
export default {
  // 頁面標題
  title: "調證建議",

  // 按鈕文本
  buttons: {
    uploadEvidence: "上傳調證",
    reset: "重置",
    query: "查詢",
    generateDocument: "生成文書",
    cancel: "取 消",
    upload: "上 傳",
    confirm: "確 定",
    downloadTemplate: "下載模板",
  },

  // 導航鏈接
  navigation: {
    illustration: "調證說明",
    platform: "調證平台",
    flowPath: "調證流程",
  },

  // 對話框標題
  dialog: {
    illustration: "調證說明",
    platform: "調證平台",
    flowPath: "調證流程",
    uploadEvidence: "上傳調證",
    downloadTemplate: "請點擊要下載的模板",
    contactService: "聯繫客服",
  },

  // 建議列表頁面 (suggestion.vue)
  suggestion: {
    // 搜索占位符
    placeholders: {
      content: "請輸入調證內容",
      platform: "請選擇調證平台",
      priority: "請選擇調證優先級",
      status: "請選擇調證狀態",
      caseName: "請輸入案件名稱",
      userId: "請輸入調證用戶ID",
      userName: "請輸入調證用戶姓名",
    },

    // 表格
    table: {
      loading: "拼命加載中",
      totalPrefix: "共計",
      totalSuffix: "條數據",
      columns: {
        content: "調證內容",
        platform: "平台",
        priority: "優先級",
        status: "狀態",
        relatedCase: "關聯案件",
        reason: "調證原因",
        creator: "添加人",
        userId: "調證用戶ID",
        userName: "調證用戶姓名",
        createTime: "添加時間",
        operation: "操作",
      },
      actions: {
        delete: "刪除",
      },
    },

    // 提示消息
    messages: {
      platformWarning: "當前僅支持批量選擇同一平台的調證內容生產文書",
      deleteConfirm: "此操作將永久刪除此條數據, 是否確定?",
      deleteTitle: "刪除確認",
      deleteSuccess: "刪除成功",
      deleteCancelled: "已取消刪除",
      confirmButton: "確定",
      cancelButton: "取消",
    },
  },

  // 上傳對話框 (uploadDialog.vue)
  upload: {
    // 說明標題
    instructionTitle: "調證上傳說明",

    // 說明內容
    instructions: {
      line1:
        "1.當前調證文件解析支持的渠道有幣安（Binance）、火幣（Huobi）、火必（Huobi-HTX）、庫幣（KuCoin）、歐易（Okx）、抹茶（Mexc）、Bitget、比特派（Bitpie）、imToken、TokenPocket、BitgetWallet等幾大主流交易所和錢包平台。",
      line2:
        "2.其他交易所文件，您可將文件上傳至平台，平台後期將會開發該交易所文件解析，當前若要解析該調證文件，可聯繫我們。",
    },

    // 表單
    form: {
      platform: "平台",
      platformPlaceholder: "請選擇(必填)",
      relatedCase: "關聯案件 (非必填)",
      casePlaceholder: "下拉選擇已有的案件",
      uploadFile: "上傳調證文件",
      note: "注：當前版本僅支持解析xlsx格式的文件，若為csv格式的文件，請先轉換為xls、xlsx格式的文件後再上傳。",
    },

    // 聯繫客服
    contact: {
      instruction: "如需聯繫客服，請掃一掃下方二維碼添加客服。",
      wechat: "微信",
    },

    // 上傳成功
    success: {
      title: "調證文件已上傳成功",
      message: "系統正在努力解析中,請耐心等待,稍後請刷新頁面查看文件解析結果。",
    },
  },

  // 對話框文本 (dialogText.vue)
  dialogContent: {
    // 調證說明
    illustration: {
      p1: "1、區塊鏈地址都是匿名的，無法直接知曉實控人身份。對涉案地址核驗分析獲得交易所線索後，可向交易所平台進行線索調證，以獲取線索背後人員的身份信息、交易行為等數據。",
      p2: '2、在案件畫布中，可對交易所線索數據一鍵加入調證建議，然後選擇需要調證的內容一鍵生成調證文書，根據調證指引操作，讓司法調證"不迷路"。',
      p3: '3、支持多家主流交易所、主流錢包公司調證文件上傳解析。圖示化展現冗雜的原始表格內容，讓調證分析"不煩瑣"。',
      p4: '4、使用人物分析ID在案件畫布中直接擴展分析，靈活展示人物轉賬關係，讓人物研判"不困難"。',
    },

    // 調證平台
    platform: {
      email: "調證郵箱：",
      subject: "建議調證郵箱標題：",
      attachments: "調證郵件附件材料：",
      notes: "其他注意事項：",
      noData: "暫無",
      noteItems: {
        note1: "1.去中心化錢包服務商的用戶資產無法凍結",
        note2:
          "2.調證的數據範圍時間範圍盡量明確，建議是調取所有時長內的信息和操作記錄",
        note3:
          "3.建議向平台明確調取的數據材料返回格式要為Excel，嚴禁圖片和PDF格式",
        note4: "4.需要要求平台加蓋公司電子公章，以便後續做證據固定使用",
        note5:
          "5.針對海外交易所，為提升調證的成功率，建議使用gov.cn等政府郵箱發送調證",
      },
    },

    // 調證流程
    flowPath: {
      step1: {
        title: "1、調證建議清單",
        content:
          "加入調證的數據會根據案件、調證平台等條件展示在調證建議頁面，用戶可在此頁面查看並對所有調證建議的明細數據進行快捷操作。",
      },
      step2: {
        title: "2、生成調證文書",
        content:
          "選擇當前所需調證的案件和平台，點擊生成文書跳轉至當前案件的調證數據詳情，根據實際需要對調證數據進行操作，確認後可以批量生成調證文書。",
      },
      step3: {
        title: "3、下載調證文書模板",
        content:
          "下載調證文書模板並根據調證文書引導對內容進行完善後發送至對應調證平台。",
      },
      step4: {
        title: "4、上傳調證文件",
        content:
          "收到平台返回的調證文件後，通過上傳調證將調證文件上傳至本系統中，系統將自動解析文件內容，用戶可在調證文件中查看解析進度。",
      },
      step5: {
        title: "5、調證文件智能解析",
        content:
          "調證文件數據解析完成後，系統將自動同步數據，用戶可在畫布中使用人物分析ID直接擴展分析，層次化的展示方式將幫助用戶更加高效、清晰、準確的進行案情研判。",
      },
    },
  },

  // 提示對話框 (Tips.vue)
  tips: {
    title: "提示",
    content:
      "當前版本暫不支持解析該交易所文件，您可將文件上傳至平台，平台後期將會開發該交易所文件解析，當前若要解析該調證文件，可",
    contactUs: "聯繫我們",
    messages: {
      uploadSuccess: "上傳原調證文件成功",
      uploadError: "上傳失敗，請刷新頁面重新上傳，或檢查網絡",
    },
  },

  // 文件上傳組件 (newOssuplodefile.vue)
  ossUpload: {
    dragText: "點擊或將文件拖拽到這裡上傳",
    supportText: "支持擴展名：.xls .xlsx",
    uploaded: "調證文件已上傳",
    uploading: "上傳中稍後......",
    uploadComplete: "上傳已完成",
    messages: {
      uploadError: "上傳失敗，請稍後上傳，或檢查網絡",
      uploadFailed: "上傳失敗，請刷新頁面，重新上傳",
      uploadFailedRefresh: "上傳失敗，請刷新頁面重新上傳，或檢查網絡",
      fileLimitWarning:
        "當前限制選擇 20 個文件，本次選擇了 {current} 個文件，共選擇了 {total} 個文件",
    },
  },

  // 調證文書頁面 (Documentfile.vue)
  documentFile: {
    title: "調證文書",
    downloadButton: "下載調證文書",
    preview: "調證文書預覽",
    methodDescription: "調證方式說明",
    loading: "拼命加載中",
    fileName: "調取證據通知書",
    fields: {
      email: "調證郵箱：",
      emailTitle: "建議調證郵箱標題：",
      attachments: "調證郵件附件材料：",
      notes: "其他注意事項：",
      noData: "暫無",
    },
    notesList: {
      note1: "1.去中心化錢包服務商的用戶資產無法凍結",
      note2:
        "2.調證的數據範圍時間範圍盡量明確，建議是調取所有時長內的信息和操作記錄",
      note3:
        "3.建議向平台明確調取的數據材料返回格式要為Excel，嚴禁圖片和PDF格式",
      note4: "4.需要要求平台加蓋公司電子公章，以便後續做證據固定使用",
      note5:
        "5.針對海外交易所，為提升調證的成功率，建議使用gov.cn等政府郵箱發送調證",
    },
  },

  // 調證用戶列表 (querysuspectser.vue)
  surveyUserList: {
    title: "調證用戶",
    placeholders: {
      userId: "請輸入用戶ID",
      name: "請輸入姓名",
      phone: "請輸入手機號",
      email: "請輸入郵箱",
      platform: "請選擇調證平台",
      idNumber: "請輸入證件號",
      caseName: "請輸入案件名稱",
    },
    buttons: {
      reset: "重置",
      query: "查詢",
      relateCase: "關聯案件",
      view: "查看",
      surveyReport: "調證報告",
    },
    table: {
      total: "共計",
      dataUnit: "條數據",
      loading: "拼命加載中",
      columns: {
        userAnalysisId: "用戶分析ID",
        name: "姓名",
        sex: "性別",
        idNumber: "證件號",
        homePlace: "籍貫",
        email: "郵箱",
        phone: "手機號",
        relatedCase: "關聯案件",
        operation: "操作",
      },
      sex: {
        unknown: "未知",
      },
    },
    messages: {
      caseUpdateSuccess: "案件修改成功",
      copySuccess: "複製成功",
    },
  },
  caseRelation: {
    title: "關聯案件",
    info: {
      title: "用戶關聯案件說明：",
      description:
        "可自行將調證用戶與本人案件進行關聯，關聯案件後對應案件中會顯示對應調證用戶數據，以便於對調證數據進行管理和分析。",
    },
    form: {
      caseLabel: "關聯案件:",
      casePlaceholder: "請選擇關聯案件",
    },
    validation: {
      caseRequired: "請選擇關聯案件",
    },
    buttons: {
      reset: "重置",
      submit: "提交",
    },
  },

  // 調證報告 (surveyReport.vue)
  surveyReport: {
    title: "調證報告",
    buttons: {
      preview: "生成報告",
      cancel: "取消",
    },
    loading: "拼命加載中",
    sections: {
      summary: "調證總結",
      personalInfo: "調證對象個人信息",
      accountBalance: "賬戶餘額情況",
      otcTransaction: "OTC交易概況",
      depositWithdrawal: "充提交易概況",
      blockchainDeposit: "鏈上充幣-幣種匯總",
      blockchainWithdraw: "鏈上提幣-幣種匯總",
      internalDeposit: "內部充幣-幣種匯總",
      internalWithdraw: "內部提幣-幣種匯總",
      keyAddress: "交易關鍵地址(非必填)",
      loginIp: "登錄IP統計",
      usedAddress: "使用過的地址",
      userBehavior: "用戶行為",
    },
    table: {
      // 個人信息表格
      personalInfo: {
        name: "姓名",
        sex: "性別",
        nationality: "國籍",
        phone: "手機號",
        idNumber: "證件號",
        email: "郵箱",
        registerTime: "註冊時間",
        age: "年齡",
      },
      // 賬戶餘額表格
      balance: {
        currency: "幣種",
        balance: "餘額",
        usdtBalance: "折合USDT",
        accountType: "賬戶類型",
        usdtAmount: "餘額（USDT）",
      },
      // OTC交易表格
      otc: {
        direction: "交易方向",
        count: "交易次數",
        legalTender: "法幣類型",
        totalAmount: "總數量",
        currency: "幣種",
        tradeAmount: "交易數量",
        buy: "買入",
        sell: "賣出",
      },
      // 充提交易表格
      deposit: {
        currency: "幣種",
        depositCount: "充幣次數",
        depositAmount: "充幣數量",
        withdrawCount: "提幣次數",
        withdrawAmount: "提幣數量",
        usdtAmount: "折合USDT",
        timeRange: "時間範圍",
      },
      // 登錄IP表格
      loginIp: {
        ipAddress: "IP地址",
        location: "IP地理位置",
        loginCount: "登錄次數",
        lastLoginTime: "最近登錄時間",
      },
      // 地址表格
      address: {
        blockchain: "鏈",
        address: "地址",
      },
      // 用戶行為表格
      behavior: {
        action: "交易行為",
        direction: "提現/充值",
        amount: "數量",
        currency: "幣種",
        time: "時間",
        deposit: "充值",
        withdraw: "提現",
      },
    },
    tips: {
      selectModule: "下方模塊可選擇",
      selectAll: "全選",
      legalTenderSummary: "法幣匯總",
      virtualCurrencySummary: "虛擬幣匯總",
      keyAddressPlaceholder: "交易關鍵地址(非必填)",
      usedAddressCount: "該賬戶使用過的交易所地址：",
      usedAddressTotal: "共{count}個",
      recentBehaviorNote: "只顯示該用戶最近操作的20條",
      noData: "暫無數據",
      notInvolved: "當前調證不涉及此數據",
    },
    radioOptions: {
      all: "全部",
      recentYear: "近一年",
      recent20: "近20條",
      commonAddress: "常用鏈地址",
    },
  },

  // 調證報告預覽 (surveyFilePreview.vue)
  surveyFilePreview: {
    title: "AI 智能研判報告",
    buttons: {
      assistance: "鑒定協助",
      edit: "編輯",
      download: "下載報告",
      downloading: "下載中",
      previousStep: "上一步",
    },
    loading: "拼命加載中",
    assistance: {
      publicAccount: "微信公眾號",
      customerService: "微信客服",
      tip: "掃碼關注微信公眾號或者添加微信客服",
    },
  },
};
